import React, { Component } from 'react';

class PreHeader extends Component {

  render() {
    return (
      <header className="usa-banner">
        <div className="usa-grid mobile-site-title start-xs col-xs">
          <span>
            This official City of Austin site is a work in progress
          </span>
        </div>
      </header>
    );
  }

}

export default PreHeader;
